export const nl = {
    'nav.today': "Overzicht Vandaag",
    'nav.calendar': "Vraagkalender",
    'nav.rates': "Tarieven & Regels",
    'nav.automation': "Automatisering",
    'nav.audit': "Audit Log",
    'nav.settings': "Instellingen",
    'sidebar.status': "Verbonden",
    'stat.occupancy': "Bezetting",
    'stat.adr': "Gem. Prijs (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Gesch. Omzet",
    'stat.trend.vsLastWeek': "vs Vorige Week",
    'stat.trend.onPace': "Op schema",
    'dashboard.actions.title': "Aanbevolen Acties",
    'dashboard.actions.empty': "Geen acties gevonden.",
    'filter.all': "Alle",
    'filter.pricing': "Prijzen",
    'filter.restriction': "Restricties",
    'action.approve': "Goedkeuren",
    'action.reject': "Afwijzen",
    'action.risk.low': "laag risico",
    'action.risk.medium': "gemiddeld risico",
    'action.risk.high': "hoog risico",
    'action.label.current': "Huidig",
    'action.label.proposed': "Voorgesteld",
    'action.metric.impact': "Impact",
    'action.metric.why': "Waarom",
    'action.status.executed': "Auto-Uitgevoerd",
    'header.search': "Zoeken...",
    'header.logout': "Uitloggen",
    'auto.level.title': "Autopilot Niveau",
    'auto.level.manual': "Handmatig",
    'auto.level.manual.desc': "U keurt elke aanbeveling goed.",
    'auto.level.assisted': "Geassisteerd",
    'auto.level.assisted.desc': "Auto-goedkeuren laag risico. Grote wijzigingen beoordelen.",
    'auto.level.auto': "Volledig Auto",
    'auto.level.auto.desc': "AI beheert prijzen 24/7 binnen uw grenzen.",
    'auto.level.active': "Actief",
    'auto.guardrails.title': "Veiligheidsgrenzen",
    'auto.guardrails.maxIncrease': "Max. Dagelijkse Stijging",
    'auto.guardrails.maxIncrease.desc': "Voorkom prijsschokken.",
    'auto.guardrails.maxDecrease': "Max. Dagelijkse Daling",
    'auto.guardrails.maxDecrease.desc': "Voorkom dumping.",
    'auto.guardrails.minRate': "Minimumprijs",
    'auto.guardrails.minRate.desc': "Verkoop nooit onder deze prijs (Netto).",
    'auto.emergency.title': "Noodbesturing",
    'auto.emergency.label': "Noodstop",
    'auto.emergency.desc': "Pauzeer onmiddellijk alle automatisering.",
    'auto.emergency.btn': "PAUZEER SYSTEEM",
    'rates.filter.all': "Alle Kamertypes",
    'rates.filter.next14': "Komende 14 Dagen",
    'rates.export': "Exporteren",
    'audit.table.time': "Tijd",
    'audit.table.actor': "Gebruiker",
    'audit.table.category': "Categorie",
    'audit.table.action': "Actie",
    'audit.table.details': "Details",
    'audit.table.status': "Status",
    'settings.pms.title': "PMS Verbinding",
    'settings.pms.connected': "Verbonden met",
    'settings.pms.disconnect': "Verbinding verbreken",
    'settings.account.title': "Account",
    'settings.account.role': "Rol",
    'settings.restart': "Onboarding Herstarten",
    'onboard.title': "Verbind PMS",
    'onboard.desc': "Selecteer uw Property Management System om te synchroniseren.",
    'onboard.connecting': "Verbinden...",
    'onboard.connect': "Verbinden",
    'onboard.success.title': "Setup Voltooid!",
    'onboard.success.desc': "**SynthHotel Berlin** is nu gesynchroniseerd.",
    'onboard.success.sub': "3 kamertypes, 14 tariefplannen en 243 boekingen geïmporteerd.",
    'onboard.btn.dashboard': "Ga naar Dashboard",
    'action.dynamic.weekend.title': "Verhoog Tarief Weekend",
    'action.dynamic.weekend.desc': "Bezetting > 75% Zaterdag, sterke vraag (+12 kamers in 24u).",
    'action.dynamic.minstay.title': "Activeer Min. Verblijf 2 Nachten",
    'action.dynamic.minstay.desc': "Taylor Swift concert. Voorkom verblijf van 1 nacht.",
    'action.dynamic.distress.title': "Verlaag Tarief (Lage Vraag)",
    'action.dynamic.distress.desc': "Bezetting 35% volgende week Dinsdag. Concurrenten verlaagd met €10.",
    'action.dynamic.gap.title': "Vul Gat: Verwijder CTA",
    'action.dynamic.gap.desc': "Gat van één nacht. Verwijder 'Gesloten voor Aankomst' om te verkopen.",
};
